import { render, staticRenderFns } from "./ConfigurazioneContabilitaSoggettiListComponent.vue?vue&type=template&id=e6be1762&scoped=true"
import script from "./ConfigurazioneContabilitaSoggettiListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaSoggettiListComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneContabilitaSoggettiListComponent.vue?vue&type=style&index=0&id=e6be1762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6be1762",
  null
  
)

export default component.exports